import { firestoreAction } from 'vuexfire'
import _ from 'lodash'
import { settingsCollection } from '@/firebase/data'

export default {
  state: {
    settings: [],
    settingsDataLoaded: false
  },
  getters: {
    getDiscountCodesByName: (state) => (name) => {

     const discountCodesSettings =  _.find(state.settings, (s) => s.name == "discountCodes")

     if (discountCodesSettings) {
        if (discountCodesSettings.codesByName[name]) {
          return discountCodesSettings.codesByName[name].codes
        } else {
          return []
        }
     } else {
      return []
     }
    }
  },
  mutations: {
    setDataLoaded (state) {
      state.storiesDataLoaded = true
    }
  },
  actions: {
    bindSettings: firestoreAction(context => {
      return context.bindFirestoreRef(
        'settings',
        settingsCollection,
        { wait: true }
      ).then(() => { context.commit('setDataLoaded') })
    }),
  }
}
